var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4.16671H0.5V5.83337H1.38333L2.06667 16.825C2.10698 17.4603 2.38806 18.0562 2.8526 18.4913C3.31715 18.9264 3.93017 19.168 4.56667 19.1667H11.4333C12.0698 19.168 12.6829 18.9264 13.1474 18.4913C13.6119 18.0562 13.893 17.4603 13.9333 16.825L14.6167 5.83337H15.5V4.16671ZM12.2667 16.7167C12.2539 16.9289 12.1605 17.1283 12.0056 17.2739C11.8507 17.4195 11.646 17.5004 11.4333 17.5H4.56667C4.35405 17.5004 4.14933 17.4195 3.99441 17.2739C3.83949 17.1283 3.74609 16.9289 3.73333 16.7167L3.05 5.83337H12.95L12.2667 16.7167ZM5.5 3.33337H3.83333C3.83333 2.67033 4.09673 2.03445 4.56557 1.56561C5.03441 1.09677 5.67029 0.833374 6.33333 0.833374H9.66667C10.3297 0.833374 10.9656 1.09677 11.4344 1.56561C11.9033 2.03445 12.1667 2.67033 12.1667 3.33337H10.5C10.5 3.11236 10.4122 2.9004 10.2559 2.74412C10.0996 2.58784 9.88768 2.50004 9.66667 2.50004H6.33333C6.11232 2.50004 5.90036 2.58784 5.74408 2.74412C5.5878 2.9004 5.5 3.11236 5.5 3.33337ZM7.16667 14.1667H5.5V9.16671H7.16667V14.1667ZM10.5 14.1667H8.83333V9.16671H10.5V14.1667Z",
    fill: "#479FCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.6b555eaa7df5493f2eb80e470186afc1.svg";
export { ForwardRef as ReactComponent };